import _ from "lodash";
import { createSlice } from "@reduxjs/toolkit";
import { createEncryptedAsyncThunk } from "../Utility/APIUtils";

const initialState = {
  comSuccess: false,
  commonResponse: {
    error: false,
    message: "",
  },
  commonDeleteResponse: {
    status: false,
    message: "",
  },
  commonDeleteSucces: false,
  error: "",
  loading: false,
};

export const getAllServicesList = createEncryptedAsyncThunk(
  "Commission/getAllServicesList",
  "Service/GetServiceMaster",
  {
    prepareBody: (params) => ({
      service_id: params.service_id || 0,
      service_name: params.service_name || "",
      service_type: params.service_type || "",
      userID: params.currentUser.userGuid,
    }),
  }
);

export const GetServiceMasterAPISwitch = createEncryptedAsyncThunk(
  "Commission/GetServiceMasterAPISwitch",
  "Service/GetServiceMasterAPISwitch",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      service_id: params.service_id || 0,
      service_name: params.service_Name || '',
    }),
  }
);

export const updateServiceMaster = createEncryptedAsyncThunk(
  "Commission/updateServiceMaster",
  "Service/UpdateServiceMaster",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      service_Id: _.toNumber(params.service_id) || 0,
      api_id: _.toNumber(params.api_id) || 0,
      status: String(params.status) || '',
      service_display_name: params.service_display_name || '',
      service_icon_path: params.service_icon_path || '',
      service_sequence: _.toNumber(params.service_sequence) || 0,
      api_keygroup_id: _.toNumber(params.api_keygroup_id) || 0,
      verification_api_id: _.toNumber(params.verification_api_id) || 0,
      customer_api_id: _.toNumber(params.customer_api_id) || 0,
      capping_amt: params.capping_amt || '',
      customer_ekyc_charges: `${parseInt(params.customer_ekyc_charges)}` || '',
      beneficary_verification_charges: `${parseInt(params.beneficary_verification_charges)}` || '',
      aeps_onboarding_charges: params.aeps_onboarding_charges || '',
      service_monthly_charges: params.service_monthly_charges || '',
      verification_keygroup_id: params.verification_keygroup_id || 0,
      api_enabled_service: params.api_enabled_service || 0,
      isvisible: params.isvisible || false,
      tpin: params.tpin || '',
      dmt_onboarding_charges: params.dmt_onboarding_charges || '',
    }),
  }
);

export const getOperatorServiceCategory = createEncryptedAsyncThunk(
  "Commission/getOperatorServiceCategory",
  "account/GetOperatorServiceCategory",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      api_id: params.api_id || 0,
      service_id: params.service_id || 0,
    }),
  }
);

export const createOperatorDetails = createEncryptedAsyncThunk(
  "Commission/createOperatorDetails",
  "Service/CreateOperatorDetails",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      serviceId: params.service_id || 0,
      api_id: params.api_id || 0,
      service_category: params.service_category || "",
      operator_id: params.operator_id || "",
      operator_name: params.operator_name || "",
      operator_code: params.operator_code || "",
      operator_display_name: params.operator_display_name || "",
      remark: params.remark || "",
      value1: params.value1 || "",
      value2: params.value2 || "",
      value3: params.value3 || "",
      value4: params.value4 || "",
      value5: params.value5 || "",
    }),
  }
);

export const updateOperatorDetails = createEncryptedAsyncThunk(
  "Commission/updateOperatorDetails",
  "Service/UpdateOperatorDetails",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      serviceCategory: params.service_category || "",
      operatorId: params.id || 0,
      serviceId: params.service_id || 0,
      updateAll: params.updateAll || false,
      value2: params.value2 || "",
      status: params.status || 0,
    }),
  }
);

export const getAllOperatorList = createEncryptedAsyncThunk(
  "RechargeSlice/getOperatorBillPayment",
  "Service/GetOperatorList",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      api_id: params.api_id || 0,
      service_id: params.service_id || 0,
      service_category: params.serviceCategory || "",
      operator_name: params.operator_name || "",
      status: params.status || 0,
      remark: params.remark || "",
      value1: params.value1 || "",
      value2: params.value2 || "",
    }),
  }
);

export const getBankListById = createEncryptedAsyncThunk(
  "commonSlice/getBankListById",
  "bank/GetBankList",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      bankid: params.bankId,
    }),
  }
);

export const getDashboardDetails = createEncryptedAsyncThunk(
  "commonSlice/getDashboardDetails",
  "Service/DashboardTransactionValuesForAdmin",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      transaction_userid: params.transaction_userid || 0,
      startDate: params.startDate || null,
      endDate: params.endDate || null,
    }),
  }
);

export const GetRecentTransactionValuesDashboard = createEncryptedAsyncThunk(
  "commonSlice/GetRecentTransactionValuesDashboard",
  "Service/GetRecentTransactionValuesDashboard",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
    }),
  }
);

export const AddBank = createEncryptedAsyncThunk(
  "commonSlice/AddBank",
  "bank/AddBankDetails",
  {
    prepareBody: (params) => ({
      bankId: params.selectBank.value,
      accountNumber: params.accountNumber,
      ifsc: params.ifscCode,
      userID: params.currentUser.userGuid,
      balanceRequestMode: ["BANK", "CASH", "ADVANCE"],
      isActive: true,
      beneficiaryName: params.beneBificiaryName,
      branchName: params.branchName,
      created_By: params.currentUser.userId,
    }),
  }
);

export const getBanklistAction = createEncryptedAsyncThunk(
  "commonSlice/getBanklistAction",
  "bank/GetBankDetailsById",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      bankuserID: params.bankuserID || 0,
    }),
  }
);

export const getAdminDashUsers = createEncryptedAsyncThunk(
  "commonSlice/getAdminDashUsers",
  "Dashboard/GETLatestUserReport",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      flag: "Admin",
    }),
  }
);

export const getTicketMasterAction = createEncryptedAsyncThunk(
  "commonSlice/getTicketMasterAction",
  "account/GetTicketMaster",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      ticketUserId: params.ticketUserId || 0,
      ticketNumber: params.ticketId || '',
      project_name: params.project_name || '',
      category: params.category || '',
      type: params.type || '',
      developer_userId: params.developer_userId || 0,
      status: params.status || [0,1,2,3,4,5],
      authPwd: params.authPwd || '',
      preLogin: true
    }),
  }
);

export const createTicketFromTicket = createEncryptedAsyncThunk(
  "ticketSystemSlice/createTicketFromTicket",
  "account/CreateTicket",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      category: params.category || '',
      type: params.type || '',
      mobileNo: params.mobileNo || '',
      subject: params.subject || '',
      project_name: params.project_name || '',
      transaction_id: params.transaction_id || '',
      description: params.description || '',
      request: params.request || '',
      response: params.response || '',
      img_data: params.img_data || '',
      authPwd: params.authPwd || '',
      developer_userId: params.currentUser.userId,
    }),
  }
);

export const updateTicketFromTicket = createEncryptedAsyncThunk(
  "ticketSystemSlice/updateTicketFromTicket",
  "account/UpdateTicket",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      complaint_id: params.complaint_id || 0,
      comp_id: params.compId || 0,
      complaint_reply_flag: params.complaint_reply_flag || 0,
      category: params.category || '',
      type: params.type || '',
      mobileNo: params.mobileNo || '',
      subject: params.subject || '',
      status: params.status || 0,
      transaction_id: params.transaction_id || '',
      description: params.description || '',
      request: params.request || '',
      response: params.response || '',
      img_data: params.img_data || '',
      resolvedBy: params.resolvedBy || '',
      resolvedRemark: params.resolvedRemark || '',
      authPwd: params.authPwd || '',
      developer_userId: params.developer_userId || 0,
    }),
  }
);

export const getDashBoardCountForAdmin = createEncryptedAsyncThunk(
  "commonSlice/getDashBoardCountForAdmin",
  "Service/DashboardCountForAdmin",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      reportUserid: `${params.currentUser.userId}`,
    }),
  }
);

export const walletBalance = createEncryptedAsyncThunk(
  "commonSlice/walletBalance",
  "account/WalletCheckBalance",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userId: params.currentUser.userId,
    }),
  }
);

export const CheckUserExist = createEncryptedAsyncThunk(
  "commonSlice/CheckUserExist",
  "account/MOS_Login",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      serviceId: params.service.serviceId,
    }),
  }
);
export const psAirtelCMSAction = createEncryptedAsyncThunk(
  "commonSlice/psAirtelCMSAction",
  "account/PSAirtelCMS",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      refid: params.refid || "",
      latitude: params.location.lattitude || '',
      longitude: params.location.longitude || '',
      serviceId: params.serviceId || 0,
    }),
  }
);

export const RBLAccountOpening = createEncryptedAsyncThunk(
  "commonSlice/RBLAccountOpening",
  "account/RBLAccountOpening",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      merchantcode: params.loginData.primaryPhone,
      serviceId: params.service.serviceId,
    }),
  }
);
export const ISkycStatusCheck = createEncryptedAsyncThunk(
  "commonSlice/ISkycStatusCheck",
  "account/IP_InitiateKYC",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      serviceId: params.serviceId.serviceId,
    }),
  }
);
export const checkKycStatus = createEncryptedAsyncThunk(
  "commonSlice/checkKycStatus",
  "account/IP_ProgressKYC",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      serviceId: params.serviceId.serviceId,
      biometricData: {
        rdsId: params.newCaptureData.rdsId,
        rdsVer: params.newCaptureData.rdsVer,
        ci: params.newCaptureData.ci,
        ts: params.newCaptureData.ts || "",
        dc: params.newCaptureData.dc,
        dpId: params.newCaptureData.dpId,
        hmac: params.newCaptureData.hmac,
        mc: params.newCaptureData.mc,
        mi: params.newCaptureData.mi,
        pidData: params.newCaptureData.pidData,
        sessionKey: params.newCaptureData.sessionKey,
      },
    }),
  }
);

export const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    commonSuccess(state) {
      return { ...state, commonResponse: true };
    },
    commonFailed(state, action) {
      return {
        ...state,
        commonResponse: { error: true, message: action.payload },
      };
    },
    FetchSuccess(state, action) {
      return { ...state, recharge: action.payload.Data[0] };
    },
    FetchFailed(state, action) {
      return {
        ...state,
        rechargeResponse: { status: true, message: action.payload },
      };
    },
    commDeleteSuccess(state) {
      return { ...state, loading: false, commonDeleteSucces: true };
    },
    commDeleteFailed(state, action) {
      return {
        ...state,
        fetchError: false,
        commonDeleteResponse: { status: true, message: action.payload },
      };
    },
    commDeleteInitial(state) {
      return {
        ...state,
        commonDeleteSucces: false,
        commonDeleteResponse: { status: false, message: "" },
      };
    },
  },
});

export const {
  commonSuccess,
  commonFailed,
  FetchSuccess,
  FetchFailed,
  commDeleteSuccess,
  commDeleteFailed,
  commDeleteInitial,
} = commonSlice.actions;
export default commonSlice.reducer;
